(function () {
	"use strict";

	angular
		.module("app")
		.component("reports", { // logged-in-home
			templateUrl: "src/app/reports/reports.html",
			controller: controller
		});

    function controller(session, reportService) {
		const $ctrl = this;
        $ctrl.session = session;
        $ctrl.reports = [];

	    $ctrl.$onInit = () => {
	        reportService.getQuarterlyRpts().then(reports => $ctrl.reports = reports);
        };

        $ctrl.openQuarterlyReport = report => {
            reportService.getQuarterlyRpt(report);
        };
    }
    controller.$inject = ["sessionService", "reportService"];

})()